import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@boozallen-uip/uswds-react-core";
import { NotificationContext } from "../pages/Notification/NotificationContext";
import { NOTIFICATIONS_URL } from "../utlities/core.constants";

export default function NotificationBell() {
  const { activeCount } = useContext(NotificationContext);
  const navigate = useNavigate();

  return (
    <div className="relative inline-flex items-center">
      <Button
        unstyled
        aria-label={`Notifications${activeCount > 0 ? `, ${activeCount} active` : ''}`}
        className="login-button-link text-sm py-2 mt-[4px] relative"
        onClick={() => navigate(NOTIFICATIONS_URL)}
      >
        <span className="text-primary-darker">
          <FontAwesomeIcon icon={faBell} aria-hidden="true" />
          {activeCount > 0 && (
            <span
              className="absolute -top-1 -right-2 bg-red text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold"
              aria-hidden="true"
            >
              {activeCount > 99 ? '99+' : activeCount}
            </span>
          )}
        </span>
      </Button>
    </div>
  );
}
